import App from 'app/app.js';
import 'app/directive/UpsellMessageCtrl.js';

function UpsellMessageDirective() {
  return {
    restrict: 'E',
    scope: {
      heading: '@',
      message: '@',
      zone: '@',
      hideClicked: '&'
    },
    template:
      '<div class="row addon-upsell" ng-show="upsellMessage.showHolidayBanner && upsellMessage.isHolidayBannerShown">' +
      '  <div class="col-xs-12 addon-upsell-head">' +
      '     <div class="upsell-information">' +
      '      <div data-id="text_link" class="upsell-close" ng-click="upsellMessage.hideHolidayBanner()"><lt-icon name="fa-sharp-solid-times" class="close-item-fa"></lt-icon></div>' +
      '       <div class="upsell-icon-header">' +
      '           <img class="holiday-icon" lt-translate-src="CYOD_GIFT_ICON" lt-zone="CYOD_PACKAGE"/>' +
      '           <div  class="holiday-heading weight-600 f-misc-18" lt-translate="{{heading}}" lt-zone="{{zone}}" /> ' +
      '       </div>' +
      '       <div  class="holiday-message weight-400 f6" lt-translate="{{message}}" lt-zone="{{zone}}" />' +
      '     </div>' +
      '  </div>' +
      '</div>' +
      '<div class="row addon-upsell" ng-show="upsellMessage.bannerVisible == true && !upsellMessage.showHolidayBanner">' +
      '  <div class="col-xs-12 addon-upsell-head">' +
      '     <div class="upsell-information">' +
      '     	<div data-id="text_link" class="upsell-close" ng-click="upsellMessage.hide()"><lt-icon name="fa-sharp-regular-times" class="close-item-fa"></lt-icon></div>' +
      '       <div class="upsell-icon-header">' +
      '           <img class="upsell-icon" <img class="upsell-icon" lt-translate-src="UPSELL_CELEBRATERY_ICON" lt-zone="{{zone}}" />' +
      '           <div ng-if="!upsellMessage.upsellCustomize" class="upsell-heading weight-600 f-misc-18" lt-translate="{{heading}}" lt-zone="{{zone}}" /> ' +
      '           <div ng-if="upsellMessage.upsellCustomize">' +
      '               <span class="upsell-heading weight-600 f-misc-18" lt-translate="{{upsellMessage.addonAdded[0].nameDesc}}" lt-zone="{{zone}}" /> ' +
      '               <span class="upsell-heading upsell-heading-text weight-600 f-misc-18" lt-translate="ADDONS_UPSELL_PRINT_ADDED_TEXT" lt-zone="MOBILE_TRANS_ADDONS"/>' +
      '           </div>' +
      '       </div>' +
      '       <div ng-if="!upsellMessage.upsellCustomize" class="upsell-message weight-600 f6" lt-translate="{{message}}" lt-zone="{{zone}}" />' +
      '       <div ng-if="upsellMessage.upsellCustomize" class="upsell-message weight-600 f6" lt-translate="ADDONS_UPSELL_SUB_TEXT" lt-zone="MOBILE_TRANS_ADDONS"/>' +
      '     </div>' +
      '  </div>' +
      '</div>',
    controller: 'UpsellMessageCtrl',
    controllerAs: 'upsellMessage'
  };
}

App.directive('upsellMessage', [UpsellMessageDirective]);
